"use client";

import { Heart, Users } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurCare() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="our-care" ref={ref} className={`w-full bg-muted/30 py-24 transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
      <div className="mx-auto max-w-7xl px-6">
        {}
        <h2 className="text-center text-4xl font-bold text-accent mb-12">
          Our Care
        </h2>

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          <p className="text-foreground leading-relaxed">At Thrive supported living services limited, we provide person-centered care tailored to each individual's needs. Our dedicated team works around the clock to ensure that every resident receives the support they deserve in a safe, nurturing environment.</p>
          <p className="text-foreground leading-relaxed">Thrive is supporting children with neuro-developmental disorders. We focus on creating a calm, predictable environment where children feel safe, understood, and valued. Our practice is guided by the Nurtured Heart Approach®, using consistent relationships, clear boundaries, and purposeful recognition to help children build confidence and emotional regulation over time.</p>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          <div className="flex flex-col gap-4 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-1" data-index="0">
            <Heart className="w-12 h-12 text-secondary2" strokeWidth={1.5} />
            <h3 className="text-xl font-semibold text-accent">24/7 at home care</h3>
            <p className="text-foreground">
              Round-the-clock support ensuring safety, comfort, and well-being at all times.
            </p>
          </div>

          <div className="flex flex-col gap-4 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-1" data-index="1">
            <Users className="w-12 h-12 text-secondary2" strokeWidth={1.5} />
            <h3 className="text-xl font-semibold text-accent">Behaviour support</h3>
            <p className="text-foreground">
              Specialized guidance to help manage challenges and promote positive development.
            </p>
          </div>
        </div>
      </div>
    </section>;
}